// /var/www/refer.lawbee.net/src/App.js

import React from 'react';
import ReferralPage from './components/ReferralPage';

function App() {
  return (
    <div className="min-h-screen">
      <ReferralPage />
    </div>
  );
}

export default App;